<template>
  <v-container fluid class="home-container">
    <v-carousel
      class="slider"
      :height="isDesktop() ? '70vh' : '280px'"
      hide-delimiter-background
      :hide-delimiters="!isDesktop()"
      cycle
      show-arrows-on-hover
    >
      <v-carousel-item v-for="(image, i) in images" :key="i">
        <img :src="image.image" align="center" class="slider-image" />
        <h2 class="image-title">{{ image.title }}</h2>
        <v-btn
          :href="image.link"
          depressed
          color="rgb(51,51,51)"
          style="color: rgb(255, 204, 0)!important;"
          class="learn-more-btn"
          light
          >{{ image.linkText }}</v-btn
        >
      </v-carousel-item>
    </v-carousel>
    <br />
    <v-row class="fill-height" align="center" justify="center">
      <p class="subheading font-weight-regular" id="home-text">
        I am motivated by the vast need for improving the human condition, and the equally vast potential for affordable human-centered technologies, such as <b>socially assistive robotics (SAR)</b>, as means of empowering people and improving human quality of life. As a pioneer of SAR and founder and director of the <a href="https://uscinteractionlab.web.app/">Interaction Lab</a> at the <a href="https://www.usc.edu">University of Southern California</a>, my research is aimed at endowing machines with the ability to <b>help people</b>, especially users with differences. My lab's focus is on developing technologies that help people help themselves, using technology to augmentat human ability rather than to automate human work. I am passionate about <A HREF="/mentor"> conveying the importance and promise</a> of interdisciplinary research and careers in STEM to all, with a particular focus on K-12 students and teachers, <A HREF="/women_in_robotics"> women </a> and other underrepresented groups in engineering and the media.
      </p>
    </v-row>
    <div class="invisible-images-for-cache">
      <img
        v-for="image in images"
        :key="image.title"
        :src="image.image"
        alt="should not be visible"
      />
    </div>
  </v-container>
</template>

<script>
// import { Carousel, Slide } from "vue-carousel";
import { getImages } from "../../service/home";

export default {
  //   components: {
  //     Carousel,
  //     Slide,
  //   },
  data() {
    return {
      images: [],
    };
  },
  mounted() {
    // get all images for sliders
    getImages()
      .then((collections) => {
        this.images = collections;
      })
      .catch((err) => {
        console.error(err.message);
      });
  },
  methods: {
    isDesktop() {
      if (
        /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return false;
      }

      return true;
    },
  },
};
</script>

<style lang="scss">
.slider-container {
  min-height: 600px;
}

.home-container {
  padding: 0;

  // introduction
  #home-text {
    width: 80%;
    font-family: "Open Sans", sans-serif !important;
    font-weight: 200 !important;
    font-size: 18px;
  }

  // slider
  .slider {
    background-color: rgba(0, 0, 0, 0.9);

    .slider-image {
      height: 100%;
      max-width: 100%;
      left: 50%;
      position: relative;
      transform: translateX(-50%);
    }

    // image title
    .image-title {
      position: absolute;
      left: 50%;
      bottom: 100px;
      color: white;
      transform: translate(-50%, 0);
      text-shadow: 1px 1px 2px black;
    }

    // learn more button
    .learn-more-btn {
      position: absolute;
      left: 50%;
      bottom: 60px;
      transform: translate(-50%, 0);
    }
  }

  // invisible image div for cache images
  .invisible-images-for-cache {
    display: none;
  }
}

/**
 * following are responsive support
 */
@media (max-width: 400px) {
  .home-container {
    .slider {
      //   height: 280px !important;

      .slider-image {
        width: 100%;
        left: 0;
        transform: none;
      }

      .image-title {
        font-size: 20px;
        width: 80%;
        text-align: center;
      }
    }

    // learn more button
    .learn-more-btn {
      bottom: 40px !important;
    }
  }
}
</style>
